define('helperComponent-parseProp',['require','helperComponent-getContentArray','helperComponent-parseContent'],function(require) {
    'use strict';

    var getContentArray = require('helperComponent-getContentArray'),
        parseContent = require('helperComponent-parseContent');

    var parseProp = function(content, prop, kind) {
        var res = [],
            arr = [];

        if (!content || !prop || typeof prop !== 'string' || !kind || typeof kind !== 'string' || !content.hasOwnProperty(prop)) {
            return res;
        }

        arr = getContentArray(content[prop], kind);

        if (!Array.isArray(arr) || !arr.length) {
            return res;
        }

        for (var i = 0; i < arr.length; i++) {
            res.push(parseContent(arr[i]));
        }

        return res;
    };

    return parseProp;
});

